import BusinessFundDetail from "./BusinessFundDetail";

export default BusinessFundDetail;
